import ExampleForm from 'src/views/Forms/Examples/ExampleForm'

// Corporate Account
import CompanyDetailsForm from 'src/views/Forms/Onboarding/CorporateAccount/CompanyDetails/CompanyDetailsForm'
import CommunicationDetailsForm from 'src/views/Forms/Onboarding/CorporateAccount/CommunicationDetails/CommunicationDetailsForm'
import CompanyStatusForm from 'src/views/Forms/Onboarding/CorporateAccount/CompanyStatus/CompanyStatusForm'
import CompanyDirectorsForm from 'src/views/Forms/Onboarding/CorporateAccount/CompanyDirectors/CompanyDirectorsForm'
import CompanyOwnershipForm from 'src/views/Forms/Onboarding/CorporateAccount/CompanyOwnership/CompanyOwnershipForm'
import SourceOfFundsForm from 'src/views/Forms/Onboarding/CorporateAccount/SourceOfFunds/SourceOfFundsForm'
import TaxResidencyForm from 'src/views/Forms/Onboarding/CorporateAccount/TaxResidency/TaxResidencyForm'
import BankDetailsForm from 'src/views/Forms/Onboarding/CorporateAccount/BankDetails/BankDetailsForm'
import PrincipalActivitiesForm from 'src/views/Forms/Onboarding/CorporateAccount/PrincipalActivities/PrincipalActivitiesForm'
import ExperienceForm from 'src/views/Forms/Onboarding/CorporateAccount/Experience/ExperienceForm'
import RepresentationsForm from 'src/views/Forms/Onboarding/CorporateAccount/Representations/RepresentationsForm'
import LegalEntityIdentifierForm from 'src/views/Forms/Onboarding/CorporateAccount/LEI/LegalEntityIdentifierForm'
import EmirTradeReportingForm from 'src/views/Forms/Onboarding/CorporateAccount/DelegatedTradeReporting/DelegatedTradeReportingForm'
import PurposeOfTradingForm from 'src/views/Forms/Onboarding/CorporateAccount/PurposeOfTrading/PurposeOfTradingForm'
import ClearingAccountPreferencesForm from 'src/views/Forms/Onboarding/CorporateAccount/ClearingAccountPreferences/ClearingAccountPreferencesForm'
import WebsiteAccessForm from 'src/views/Forms/Onboarding/CorporateAccount/WebsiteAccess/WebsiteAccessForm'
import ConsentsForm from 'src/views/Forms/Onboarding/CorporateAccount/Consents/ConsentsForm'
import ReverseSolicitationForm from 'src/views/Forms/Onboarding/CorporateAccount/ReverseSolicitation/ReverseSolicitationForm'
import CCPClearingServicesForm from 'src/views/Forms/Onboarding/CorporateAccount/CCPClearingServices/CCPClearingServicesForm'
import IndividuallyAgreedTermsScheduleForm from 'src/views/Forms/Onboarding/CorporateAccount/IndividuallyAgreedTermsSchedule/IndividuallyAgreedTermsSchedule'
import DeclarationsForm from 'src/views/Forms/Onboarding/CorporateAccount/Declarations/DeclarationsForm'
import UkProcessAgentForm from 'src/views/Forms/Onboarding/CorporateAccount/UkProcessAgent/UkProcessAgentForm'
import ConflictOfInterestsForm from 'src/views/Forms/Onboarding/CorporateAccount/ConflictOfInterests/ConflictOfInterestsForm'

// Individual Account
import IndividualAccountOpeningDocumentationForm from 'src/views/Forms/Onboarding/IndividualAccount/IndividualAccountOpeningDocumentation/IndividualAccountOpeningDocumentationForm'
import IndividualTaxResidencyForm from 'src/views/Forms/Onboarding/IndividualAccount/TaxResidency/IndividualTaxResidency'
import IndividualBankDetailsForm from 'src/views/Forms/Onboarding/IndividualAccount/BankDetails/BankDetailsForm'
import IndividualFinancialSituationForm from 'src/views/Forms/Onboarding/IndividualAccount/FinancialSituation/FinancialSituationForm'
import IndividualPersonalDetailsForm from 'src/views/Forms/Onboarding/IndividualAccount/PersonalDetails/PersonalDetailsForm'
import IndividualOpeningTradingAccountForm from 'src/views/Forms/Onboarding/IndividualAccount/OpeningTradingAccount/OpeningTradingAccountForm'
import IndividualExperienceForm from 'src/views/Forms/Onboarding/IndividualAccount/Experience/ExperienceForm'
import InvestmentObjectivesForm from 'src/views/Forms/Onboarding/IndividualAccount/InvestmentObjectives/InvestmentObjectivesForm'
import IndividualWebsiteAccessForm from 'src/views/Forms/Onboarding/IndividualAccount/WebsiteAccess/WebsiteAccessForm'
import IndividualConsentsForm from 'src/views/Forms/Onboarding/IndividualAccount/Consents/ConsentsForm'
import IndividualReverseSolicitationForm from 'src/views/Forms/Onboarding/IndividualAccount/ReverseSolicitation/ReverseSolicitationForm'
import IndividualDeclarationsForm from 'src/views/Forms/Onboarding/IndividualAccount/Declarations/DeclarationsForm'
// import IndividualUkProcessAgentForm from 'src/views/Forms/Onboarding/IndividualAccount/UkProcessAgent/UkProcessAgentForm'
// import ConflictOfInterestsForm from 'src/views/Forms/Onboarding/IndividualAccount/ConflictOfInterests/ConflictOfInterestsForm'

// Deliverables Account, some of the forms are imported from the Corporate Account since they are the same with only the endpoints changed
import DeliverableCompanyDirectorsForm from 'src/views/Forms/Onboarding/DeliverableAccount/CompanyDirectors/CompanyDirectorsForm'
import DeliverableCompanyOwnershipForm from 'src/views/Forms/Onboarding/DeliverableAccount/CompanyOwnership/CompanyOwnershipForm'
import DeliverableTaxResidencyForm from 'src/views/Forms/Onboarding/DeliverableAccount/TaxResidency/TaxResidencyForm'
import DeliverableWebsiteAccessForm from 'src/views/Forms/Onboarding/DeliverableAccount/WebsiteAccess/WebsiteAccessForm'
import DeliverableDeclarationsForm from 'src/views/Forms/Onboarding/DeliverableAccount/Declarations/DeclarationsForm'

import SignatureForm from 'src/views/Forms/Onboarding/Signature/SignatureForm'

import { FormConfig, FlowGroupType } from './types'
import { getBaseApiHost } from 'src/components/Core/Utils/url_constants'
import AuthorizedSignatoriesForm from 'src/views/Forms/Onboarding/CorporateAccount/AuthorizedSignatories/AuthorizedSignatoriesForm'
import IndividualUkProcessAgentForm from 'src/views/Forms/Onboarding/IndividualAccount/UkProcessAgent/IndividualUkProcessAgentForm'

const FRONT_MOCK: boolean = (import.meta.env.VITE_MOCK_DATA || 'false') === 'true'
const HOST: string = getBaseApiHost()
const ORIGIN: string = window.location.origin
export const CORP_SEND_FILE_URL = FRONT_MOCK
  ? `${ORIGIN}/mock/postMessage.json`
  : `${HOST}/CorpAOF/uploadDocument`
export const DELIVERABLE_SEND_FILE_URL = FRONT_MOCK
  ? `${ORIGIN}/mock/postMessage.json`
  : `${HOST}/DeliverableAOF/uploadDocument`
export const INDIVIDUAL_SEND_FILE_URL = FRONT_MOCK
  ? `${ORIGIN}/mock/postMessage.json`
  : `${HOST}/IndividualAOF/uploadDocument`

const individualFlowConfig: FormConfig[] = [
  {
    key: 'AccountOpeningDocumentationForm',
    name: 'Account Opening Documentation',
    form: IndividualAccountOpeningDocumentationForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/accopeningdocs.json`
      : `${HOST}/IndividualAOF/getaccountopeningdocumentation01`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updateaccountopeningdocumentation01`,
  },
  {
    key: 'PersonalDetailsForm',
    name: 'Personal Details',
    form: IndividualPersonalDetailsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/individualPersonalDetails.json`
      : `${HOST}/IndividualAOF/getpersonaldetails02`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updatepersonaldetails02`,
  },
  {
    key: 'TaxResidencyForm',
    name: 'Tax Residency',
    form: IndividualTaxResidencyForm,
  },
  {
    key: 'BankDetailsForm',
    form: IndividualBankDetailsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/bankDetailsIndividual.json`
      : `${HOST}/IndividualAOF/getbankdetails04`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updatebankdetails04`,
  },
  {
    key: 'FinancialSituationForm',
    name: 'Financial Situation',
    form: IndividualFinancialSituationForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/financialSituation.json`
      : `${HOST}/IndividualAOF/getfinancialsituation05`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updatefinancialsituation05`,
  },
  {
    key: 'OpeningTradingAccountForm',
    name: 'Opening a Trading Account',
    form: IndividualOpeningTradingAccountForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/openingTradingAccountForm.json`
      : `${HOST}/IndividualAOF/getopeningatradingaccount06`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updateopeningatradingaccount06`,
  },
  {
    key: 'InvestmentObjectivesForm',
    name: 'Investment Objectives',
    form: InvestmentObjectivesForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/investmentObjectivesForm.json`
      : `${HOST}/IndividualAOF/getinvestmentobjectives07`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updateinvestmentobjectives07`,
  },
  {
    key: 'ExperienceForm',
    name: 'Experience',
    form: IndividualExperienceForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/individualExperienceForm.json`
      : `${HOST}/IndividualAOF/getexperience08`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updateexperience08`,
  },
  {
    key: 'ConflictOfInterestsForm',
    name: 'ConflictOfInterests',
    form: ConflictOfInterestsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/conflictsOfInterest.json`
      : `${HOST}/IndividualAOF/getconflictsofinterest09`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updateconflictsofinterest09`,
  },
  {
    key: 'WebsiteAccessForm',
    name: 'Website Access',
    form: IndividualWebsiteAccessForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/individualWebsiteAccessForm.json`
      : `${HOST}/IndividualAOF/getwebsiteaccess10`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updatewebsiteaccess10`,
  },
  {
    key: 'ConsentsForm',
    name: 'Consents',
    form: IndividualConsentsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/individualConsentsForm.json`
      : `${HOST}/IndividualAOF/getconsents11`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updateconsents11`,
  },
  {
    key: 'ReverseSolicitationForm',
    name: 'Reverse Solicitation (EEA)',
    form: IndividualReverseSolicitationForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/reverseSolicitation.json`
      : `${HOST}/IndividualAOF/getreversesolicitation12`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updatereversesolicitation12`,
  },
  {
    key: 'IndividuallyAgreedTermsScheduleForm',
    name: 'Individually Agreed Terms Schedule',
    form: IndividuallyAgreedTermsScheduleForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/individuallyAgreedTermsSchedule.json`
      : `${HOST}/IndividualAOF/GetIndividuallyAgreedTermsSchedule13`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/UpdateIndividuallyAgreedTermsSchedule13`,
  },
  {
    key: 'DeclarationsForm',
    name: 'Declarations',
    form: IndividualDeclarationsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/individualDeclarations.json`
      : `${HOST}/IndividualAOF/getdeclarations14`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updatedeclarations14`,
  },
  {
    key: 'UkProcessAgentForm',
    name: 'UkProcessAgent',
    form: IndividualUkProcessAgentForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/individualUkProcessAgent.json`
      : `${HOST}/IndividualAOF/getukprocessagent15`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/IndividualAOF/updateukprocessagent15`,
  },
  {
    key: 'SignatureForm',
    name: 'Signature',
    form: SignatureForm,
  },
]

const deliverableFlowConfig: FormConfig[] = [
  {
    key: 'CompanyDetailsForm',
    name: 'Company Details',
    form: CompanyDetailsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/companyDetails.json`
      : `${HOST}/DeliverableAOF/getcompanydetails01`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updatecompanydetails01`,
    type: 'Deliverable',
  },
  {
    key: 'CommunicationDetailsForm',
    name: 'Communication Details',
    form: CommunicationDetailsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/deliverableCommunicationDetails.json`
      : `${HOST}/DeliverableAOF/getcommunicationdetails02`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updatecommunicationdetails02`,
    type: 'Deliverable',
  },
  {
    key: 'CompanyStatusForm',
    name: 'Company Status',
    form: CompanyStatusForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/companyStatus.json`
      : `${HOST}/DeliverableAOF/getcompanystatus03`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updatecompanystatus03`,
    type: 'Deliverable',
  },
  {
    key: 'CompanyDirectorsForm',
    name: 'Company Directors',
    form: DeliverableCompanyDirectorsForm,
  },
  {
    key: 'CompanyOwnershipForm',
    name: 'Company Ownership',
    form: DeliverableCompanyOwnershipForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/allShareholderDetails.json`
      : `${HOST}/DeliverableAOF/getshareholderdetails05`,
  },
  {
    key: 'SourceOfFundsForm',
    name: 'Source of Funds',
    form: SourceOfFundsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/sourceOfFunds.json`
      : `${HOST}/DeliverableAOF/getsourceoffunds06`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updatesourceoffunds06`,
  },
  {
    key: 'TaxResidencyForm',
    name: 'Tax Residency',
    form: DeliverableTaxResidencyForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/taxResidency.json`
      : `${HOST}/DeliverableAOF/gettaxresidency07`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updatetaxresidency07`,
  },
  {
    key: 'BankDetailsForm',
    name: 'Bank Details',
    form: BankDetailsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/bankDetails.json`
      : `${HOST}/DeliverableAOF/getbankdetails08`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updatebankdetails08`,
    type: 'Deliverable'
  },
  {
    key: 'PrincipalActivitiesForm',
    name: 'Principal Activities',
    form: PrincipalActivitiesForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/principalActivities.json`
      : `${HOST}/DeliverableAOF/getprincipalactivities11`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updateprincipalactivities11`,
  },
  {
    key: 'ConflictOfInterestsForm',
    name: 'ConflictOfInterests',
    form: ConflictOfInterestsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/conflictsOfInterest.json`
      : `${HOST}/DeliverableAOF/getconflictsofinterest15`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updateconflictsofinterest15`,
  },
  {
    key: 'WebsiteAccessForm',
    name: 'Website Access',
    form: DeliverableWebsiteAccessForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/deliverableWebsiteAccess.json`
      : `${HOST}/DeliverableAOF/getwebsiteaccess12`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updatewebsiteaccess12`,
  },
  {
    key: 'ReverseSolicitationForm',
    name: 'Reverse Solicitation (EEA)',
    form: ReverseSolicitationForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/reverseSolicitation.json`
      : `${HOST}/DeliverableAOF/getReverseSolicitation13`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/UpdateReverseSolicitation13`,
  },
  {
    key: 'IndividuallyAgreedTermsScheduleForm',
    name: 'Individually Agreed Terms Schedule',
    form: IndividuallyAgreedTermsScheduleForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/individuallyAgreedTermsSchedule.json`
      : `${HOST}/DeliverableAOF/GetIndividuallyAgreedTermsSchedule17`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/UpdateIndividuallyAgreedTermsSchedule17`,
  },
  {
    key: 'DeclarationsForm',
    name: 'Declarations',
    form: DeliverableDeclarationsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/deliverableDeclarations.json`
      : `${HOST}/DeliverableAOF/getdeclarations14`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updatedeclarations14`,
  },
  {
    key: 'UkProcessAgentForm',
    name: 'UkProcessAgent',
    form: UkProcessAgentForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/ukProcessAgent.json`
      : `${HOST}/DeliverableAOF/getukProcessAgent16`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/DeliverableAOF/updateukProcessAgent16`,
  },
  {
    key: 'AuthorizedSignatoriesForm',
    name: 'AuthorizedSignatories',
    form: AuthorizedSignatoriesForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/authorizedSignatoriesDeli.json`
      : `${HOST}/DeliverableAOF/getSignatories18`,
  },
  {
    key: 'SignatureForm',
    name: 'Signature',
    form: SignatureForm,
  },
]

const corporateFlowConfig: FormConfig[] = [
  {
    key: 'CompanyDetailsForm',
    name: 'Company Details',
    form: CompanyDetailsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/companyDetails.json`
      : `${HOST}/CorpAOF/getcompanydetails01`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatecompanydetails01`,
  },
  {
    key: 'CommunicationDetailsForm',
    name: 'Communication Details',
    form: CommunicationDetailsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/communicationDetails.json`
      : `${HOST}/CorpAOF/getcommunicationdetails02`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatecommunicationdetails02`,
  },
  {
    key: 'CompanyStatusForm',
    name: 'Company Status',
    form: CompanyStatusForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/companyStatus.json`
      : `${HOST}/CorpAOF/getcompanystatus03`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatecompanystatus03`,
  },
  {
    key: 'CompanyDirectorsForm',
    name: 'Company Directors',
    form: CompanyDirectorsForm,
  },
  {
    key: 'CompanyOwnershipForm',
    name: 'Company Ownership',
    form: CompanyOwnershipForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/allShareholderDetails.json`
      : `${HOST}/CorpAOF/getshareholderdetails05`,
  },
  {
    key: 'SourceOfFundsForm',
    name: 'Source of Funds',
    form: SourceOfFundsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/sourceOfFunds.json`
      : `${HOST}/CorpAOF/getsourceoffunds06`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatesourceoffunds06`,
  },
  {
    key: 'TaxResidencyForm',
    name: 'Tax Residency',
    form: TaxResidencyForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/taxResidency.json`
      : `${HOST}/CorpAOF/gettaxresidency07`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatetaxresidency07`,
  },
  {
    key: 'BankDetailsForm',
    name: 'Bank Details ',
    form: BankDetailsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/bankDetails.json`
      : `${HOST}/CorpAOF/getbankdetails08`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatebankdetails08`,
  },
  {
    key: 'PrincipalActivitiesForm',
    name: 'Principal Activities',
    form: PrincipalActivitiesForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/principalActivities.json`
      : `${HOST}/CorpAOF/getprincipalactivities09`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updateprincipalactivities09`,
  },
  {
    key: 'ExperienceForm',
    name: 'Experience',
    form: ExperienceForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/experience.json`
      : `${HOST}/CorpAOF/getExperience10`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updateexperience10`,
  },
  {
    key: 'RepresentationsForm',
    name: 'Representations',
    form: RepresentationsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/representations.json`
      : `${HOST}/CorpAOF/getrepresentations11`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updaterepresentations11`,
  },
  {
    key: 'EmirTradeReportingForm',
    name: 'Delegated Trade Reporting',
    form: EmirTradeReportingForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/delegatedTradeReporting.json`
      : `${HOST}/CorpAOF/getdelegatedtradereporting12`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatedelegatedtradereporting12`,
  },
  {
    key: 'LegalEntityIdentifierForm',
    name: 'LegalEntityIdentifierForm',
    form: LegalEntityIdentifierForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/legalEntityIdentifier.json`
      : `${HOST}/CorpAOF/getLegalentityidentifier13`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatelegalentityidentifier13`,
  },
  {
    key: 'ConflictOfInterestsForm',
    name: 'ConflictOfInterests',
    form: ConflictOfInterestsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/conflictsOfInterest.json`
      : `${HOST}/CorpAOF/getconflictsofinterest22`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updateconflictsofinterest22`,
  },
  {
    key: 'PurposeOfTradingForm',
    name: 'Purpose of Trading Derivative Products',
    form: PurposeOfTradingForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/purposeOfTrading.json`
      : `${HOST}/CorpAOF/getpurposeoftrading14`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatepurposeoftrading14`,
  },
  {
    key: 'ClearingAccountPreferencesForm',
    name: 'Clearing Account Preferences',
    form: ClearingAccountPreferencesForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/clearingAccountPreferences.json`
      : `${HOST}/CorpAOF/getclearingaccountpreferences15`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updateclearingaccountpreferences15`,
  },
  {
    key: 'WebsiteAccessForm',
    name: 'Website Access',
    form: WebsiteAccessForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/websiteAccess.json`
      : `${HOST}/CorpAOF/getwebsiteaccess16`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatewebsiteaccess16`,
  },
  {
    key: 'ConsentsForm',
    name: 'Consents',
    form: ConsentsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/consents.json`
      : `${HOST}/CorpAOF/getconsents17`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updateconsents17`,
  },
  {
    key: 'ReverseSolicitationForm',
    name: 'Reverse Solicitation (EEA)',
    form: ReverseSolicitationForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/reverseSolicitation.json`
      : `${HOST}/CorpAOF/getReverseSolicitation18`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/UpdateReverseSolicitation18`,
  },
  {
    key: 'CCPClearingServicesForm',
    name: 'CCP Clearing Services',
    form: CCPClearingServicesForm,
  },
  {
    key: 'IndividuallyAgreedTermsScheduleForm',
    name: 'Individually Agreed Terms Schedule',
    form: IndividuallyAgreedTermsScheduleForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/individuallyAgreedTermsSchedule.json`
      : `${HOST}/CorpAOF/getindividuallyagreedtermsschedule20`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updateindividuallyagreedtermsschedule20`,
  },
  {
    key: 'DeclarationsForm',
    name: 'Declarations',
    form: DeclarationsForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/declarations.json`
      : `${HOST}/CorpAOF/getdeclarations21`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updatedeclarations21`,
  },
  {
    key: 'UkProcessAgentForm',
    name: 'UkProcessAgent',
    form: UkProcessAgentForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/ukProcessAgent.json`
      : `${HOST}/CorpAOF/getukprocessagent23`,
    postUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/postMessage.json`
      : `${HOST}/CorpAOF/updateukprocessagent23`,
  },
  {
    key: 'AuthorizedSignatoriesForm',
    name: 'AuthorizedSignatories',
    form: AuthorizedSignatoriesForm,
    fetchUrl: FRONT_MOCK
      ? `${ORIGIN}/mock/authorizedSignatories.json`
      : `${HOST}/CorpAOF/getSignatories24`,
    type: 'Corporate'
  },
  {
    key: 'SignatureForm',
    name: 'Signature',
    form: SignatureForm,
  },
]

const defaultFlowConfig: FormConfig[] = [
  {
    name: 'Bank Details',
    form: BankDetailsForm,
    fetchUrl: `${ORIGIN}/mock/bankDetails.json`,
    postUrl: `${ORIGIN}/mock/postMessage.json`,
  },
  {
    name: 'Company Ownership',
    form: CompanyOwnershipForm,
    fetchUrl: `${ORIGIN}/mock/sourceOfFunds.json`,
    postUrl: `${ORIGIN}/mock/postMessage.json`,
  },
  {
    name: 'Example',
    form: ExampleForm,
    fetchUrl: `${ORIGIN}/mock/exampleFormDetails.json`,
    postUrl: `${ORIGIN}/mock/postMessage.json`,
  },
]

const getFlowConfig = (key?: FlowGroupType | string): FormConfig[] => {
  if(key === 'IndividualAccount') return individualFlowConfig
  if(key === 'DeliverableAccount') return deliverableFlowConfig
  if(key === 'CorporateAccount') return corporateFlowConfig
  return defaultFlowConfig
}

export const getApplicationType = (key?: FlowGroupType | string): 'CorporateAccount' | 'DeliverableAccount' | 'IndividualAccount' | null => {
  if(key === 'CorpAOF') return 'CorporateAccount'
  if(key === 'DeliverableAOF') return 'DeliverableAccount'
  if(key === 'IndividualAOF') return 'IndividualAccount'
  return null
}

export default getFlowConfig
